import Partitions from './Partitions';
import LoadingDocks from './LoadingDocks';
import Storage from './Storage';
import Devices from './Devices';
import Ceiling from './Ceiling';
import Door from './Door';
import Furniture from './Furniture';

const floorPlanElements = {
  partitions: Partitions,
  loadingDocks: LoadingDocks,
  storage : Storage,
  devices: Devices,
  ceiling: Ceiling,
  door: Door,
  furniture: Furniture
};

export default floorPlanElements;